import React, { useState } from "react";

import { LegacyPortalAccountService } from "@spwn-portal/grpc";

import { buildStartggAuthorizeUrl } from "./startggAuthorize";
import { startggConfig, startggRegisterEmbedUrl } from "./startggConfig";
import { useStartggLink } from "./useStartggLink";
import { useConnectClient } from "../../utility/connectWeb";

type EntryStatus = {
  entered: boolean;
  gamerTag: string;
  pool: string;
  seedNum: number;
};

/**
 * start.gg 連携 PoC の検証ページ（/evoj/entry）。デザインは最小。
 * ①連携 → ②entry 状況取得 → ③登録 iframe → 再度②で entered=true を確認、の一周を検証する。
 */
export const EvojEntryPage: React.FC = () => {
  const { link, isLoading } = useStartggLink();
  const client = useConnectClient(LegacyPortalAccountService);
  const [status, setStatus] = useState<EntryStatus | null>(null);
  const [checking, setChecking] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const startLink = () => {
    window.location.assign(buildStartggAuthorizeUrl());
  };

  const checkEntry = async () => {
    if (!link) {
      return;
    }
    setChecking(true);
    setError(null);
    try {
      const res = await client.getStartggEntryStatus({
        startggUserId: link.userId,
        eventId: startggConfig.eventId,
      });
      setStatus({
        entered: res.entered,
        gamerTag: res.gamerTag,
        pool: res.pool,
        seedNum: res.seedNum,
      });
    } catch (e) {
      console.error(e);
      setError("entry 状況の取得に失敗しました。");
    } finally {
      setChecking(false);
    }
  };

  return (
    <div style={{ padding: 24, maxWidth: 720, margin: "0 auto" }}>
      <h1>EVOJ × start.gg 連携 PoC</h1>

      <section style={sectionStyle}>
        <h2>① start.gg 連携</h2>
        {isLoading ? (
          <p>読み込み中…</p>
        ) : link ? (
          <p>
            連携済み: <strong>{link.username}</strong>（start.gg user.id:{" "}
            {link.userId}）
          </p>
        ) : (
          <React.Fragment>
            <p>未連携です。</p>
            <button type="button" onClick={startLink}>
              start.gg と連携する
            </button>
          </React.Fragment>
        )}
      </section>

      <section style={sectionStyle}>
        <h2>② entry 状況</h2>
        <button type="button" onClick={checkEntry} disabled={!link || checking}>
          {checking ? "確認中…" : "entry 状況を確認"}
        </button>
        {error && <p style={{ color: "#c0392b" }}>{error}</p>}
        {status && (
          <ul>
            <li>entered: {status.entered ? "true ✅" : "false"}</li>
            <li>gamerTag: {status.gamerTag || "-"}</li>
            <li>pool（ブロック）: {status.pool || "未確定"}</li>
            <li>seedNum: {status.seedNum || "未確定"}</li>
          </ul>
        )}
      </section>

      <section style={sectionStyle}>
        <h2>③ start.gg 登録フォーム（埋め込み）</h2>
        {startggConfig.tournamentSlug ? (
          <iframe
            title="start.gg register"
            src={startggRegisterEmbedUrl()}
            style={{ width: "100%", height: 640, border: "1px solid #ccc" }}
          />
        ) : (
          <p>REACT_APP_STARTGG_TOURNAMENT_SLUG が未設定です。</p>
        )}
        <p style={{ fontSize: 12, color: "#666" }}>
          登録後、②の「entry 状況を確認」を押すと entered が true になります。
        </p>
      </section>
    </div>
  );
};

const sectionStyle: React.CSSProperties = {
  border: "1px solid #e3e6ea",
  borderRadius: 8,
  padding: 16,
  marginBottom: 16,
};
